import { useEffect, useRef, useState } from "react";
import { reducedMotion } from "../../lib/motion";

export const HeroVideo = () => {
  const ref = useRef(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (reducedMotion() || navigator.connection?.saveData) return undefined;
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
    const id = idle(() => setLoad(true));
    return () => (window.cancelIdleCallback ? window.cancelIdleCallback(id) : clearTimeout(id));
  }, []);

  useEffect(() => {
    const v = ref.current;
    if (!load || !v) return undefined;
    const io = new IntersectionObserver(([e]) => (e.isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.05 });
    io.observe(v);
    return () => io.disconnect();
  }, [load]);

  return (
    <div className="hero-media" aria-hidden="true">
      <div className="aurora" />
      <img className="hero-poster" src="/media/hero-poster.webp" alt="" width="1280" height="720" fetchPriority="high" />
      {load && (
        <video ref={ref} className="hero-video" muted loop playsInline autoPlay preload="auto" poster="/media/hero-poster.webp"
          onPlaying={(e) => e.currentTarget.classList.add("is-playing")} data-testid="hero-video">
          <source src="/media/hero-loop.webm" type="video/webm" />
          <source src="/media/hero-loop.mp4" type="video/mp4" />
        </video>
      )}
      <div className="hero-overlay" />
    </div>
  );
};
